import React from 'react';
import Avatar from '@components/avatar/Avatar';
import Button from '@components/form/Button';
import { Link } from 'react-router-dom';
import logoBrocom from '@images/brocom-logo-2.png';
import FilesList from './options/FilesList';
import IncludedPolicies from './policies/IncludedPolicies';
import ExcludePolicies from './policies/ExcludedPolicies';
import Options from './options/Options';

function appendToString(str, appendee) {
  return (str.length > 0) ? `${str}, ${appendee}` : str + appendee;
}

function Order({
  form, summary, compute, pathToConfirm,
}) {
  const setOption = (option) => {
    compute(option);
  };

  const priceException = () => {
    let casesString = '';
    if (form.water_skiing === 'true') casesString = appendToString(casesString, 'la tractation d\'une bouée ou ski nautique');
    if (form.has_incident === 'true') casesString = appendToString(casesString, 'le fait de déjà avoir une des sinistres');
    if (form.is_registered_belgium === 'false') casesString = appendToString(casesString, 'le fait de ne pas être immatriculé en Belgique');

    return (
      (casesString.length > 0 && (
      <p className="mt-6 text-gray-700 text-sm md:max-w-2xl">
        <span className="mr-3">⚠️</span>
        <span className="capitalize-first">
          {casesString}
          {' '}
          , peut faire varier le prix.
        </span>
      </p>
      )
      )
    );
  };

  return (
    <>
      <div className="md:sticky fixed w-full bg-white border-b border-gray-50 items-center flex-wrap py-5 m-auto top-0 animated z-10">
        <div className="flex justify-between px-8 ">
          <a className="hidden md:flex items-center group hover:scale-110 transform transition block" href="tel:3224790099">
            <i className="fad fa-phone-alt text-primary text-2xl mr-6" />
            <div className="text-left">
              <div className="text-sm">Vous pouvez me joindre au</div>
              <div className="text-sm text-primary">+32 2 479 00 99</div>
            </div>
          </a>
          <div className="flex items-center">
            <div className="mr-3">
              <span className="text-xl font-black">{summary.price}</span>
              <span className="text-sm">€/an</span>
            </div>
            <Link to={pathToConfirm}><Button.Primary size="md" label="Ça me convient" /></Link>
          </div>
        </div>
      </div>

      <div className="w-full text-center flex justify-center flex-col items-center">
        <section className="w-full pb-16 md:pb-24 text-center flex justify-center flex-col items-center">
          <p className="md:max-w-3xl font-serif text-4xl md:text-6xl text-gray-800 mt-6 md:mt-24">
            Merci
            {' '}
            {form.first_name}
            ,
            <br />
            {' '}
            votre prime est personnalisée.
          </p>
          <div className="bg-gradient-primary text-white rounded-3xl px-6 py-4 mt-6 md:mt-16">
            <span className="text-3xl font-black">{summary.price}</span>
            <span>€</span>
            <div className="uppercase text-xs">par an</div>
          </div>

          <div className="mt-6">
            <Link to={pathToConfirm}><Button.Primary label="Ça me convient" /></Link>
          </div>

          { priceException() }
        </section>

        <section className="w-full px-6 py-16 md:py-16 text-center flex justify-center flex-col items-center w-full ">
          <h2 className="text-3xl md:text-5xl font-black text-gray-800 mb-4">Ce qui est couvert</h2>
          <div className="mt-16 w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:max-w-4xl m-auto">
              <IncludedPolicies form={form} />
            </div>
          </div>
        </section>

        <section id="personnaliser" className="w-full px-6 py-16 md:py-24 text-center flex justify-center flex-col items-center w-full ">
          <h2 className="text-3xl md:text-5xl font-black text-gray-800">Options complémentaires</h2>
          <p className="text-sm md:text-base mt-4 text-gray-500">
            J'ai sélectionné les options sur base de notre entretien.
            <br />
            Elles permettent d’améliorer et de personnaliser votre couverture.
            <br />
            Libre à vous de les modifier :-)
          </p>
          <div className="mt-16 w-auto max-w-2xl">
            <Options.set1 setOption={setOption} form={form} summary={summary} />
          </div>
        </section>

        <section className="w-full px-6 py-16 md:py-16 text-center flex justify-center flex-col items-center w-full ">
          <h2 className="text-3xl md:text-5xl font-black text-gray-800 mb-4">Ce qui n'est pas couvert</h2>
          <div className="mt-16 w-auto ">
            <div className="grid md:grid-cols-2 gap-8 md:gap-16 md:max-w-4xl m-auto">
              <ExcludePolicies form={form} />
            </div>
          </div>

          <div className="mt-20"><FilesList /></div>
          <img className="mt-10 md:w-1/3" src={logoBrocom} />
        </section>

        <section className="md:hidden w-full py-16 mt-16 px-6 bg-gradient-primary w-full flex flex-col items-center justify-center">
          <Avatar />
          <p className="font-serif text-2xl text-white mt-6 font-bold">Nous pouvons parcourir ta couverture ensemble.</p>
          <div className="mt-12">
            <Button.Secondary label="Discuter" icon={<i className="fad fa-comments mr-4 text-primary text-xl" />} onClick={() => $crisp.push(['do', 'chat:open'])} />
            <a href="tel:3224790099">
              <Button.Secondary className="mt-3" label="Téléphoner" icon={<i className="fad fa-phone-alt mr-4 text-primary text-xl" />} />
            </a>
          </div>
        </section>
      </div>
    </>
  );
}

export default Order;
